var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showRecommendButton)?_c('el-button',{staticClass:"recommend-button",attrs:{"loading":_vm.recommendButtonLoading},on:{"click":_vm.recommendToLibrary}},[_vm._v("\n  推荐我的图书馆购买\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a32fda6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecommendButton.vue
// module id = null
// module chunks = 